const isUpdateAvailable = state => Boolean(state.autoUpdates.isUpdateAvailable);
const isOutsideApplications = state => Boolean(state.autoUpdates.isOutsideApplications);
const isDownloading = state => Boolean(state.autoUpdates.isDownloading);
const didDownloadFail = state => Boolean(state.autoUpdates.didDownloadFail);
const showUpdateModal = state => Boolean(state.autoUpdates.showUpdateModal);
const showReleaseNotesModal = state =>
  Boolean(state.autoUpdates.availableReleaseNotes && state.autoUpdates.isReleaseNotesNew);
const isReadyToInstall = state => Boolean(state.autoUpdates.isReadyToInstall);
const getCurrentShell = state => state.autoUpdates.currentShell;
const getCurrentEditor = state => state.autoUpdates.currentEditor;
const getCurrentReader = state => state.autoUpdates.currentReader;
const getAvailableEditor = state => state.autoUpdates.availableEditor;
const getAvailableReader = state => state.autoUpdates.availableReader;
const getAvailableReleaseNotes = state => state.autoUpdates.availableReleaseNotes;
const getIsReleaseNotesNew = state => state.autoUpdates.isReleaseNotesNew;
const getUseAppStore = state => state.autoUpdates.useAppStore;

const getAutoUpdatesData = state => state.autoUpdates;

export default {
  getAutoUpdatesData,
  isUpdateAvailable,
  isDownloading,
  isReadyToInstall,
  isOutsideApplications,
  didDownloadFail,
  showUpdateModal,
  showReleaseNotesModal,
  getCurrentEditor,
  getCurrentReader,
  getCurrentShell,
  getAvailableEditor,
  getAvailableReader,
  getAvailableReleaseNotes,
  getIsReleaseNotesNew,
  getUseAppStore
};
